import { render } from "./readEventClub.vue?vue&type=template&id=039639a2"
import script from "./readEventClub.vue?vue&type=script&lang=js"
export * from "./readEventClub.vue?vue&type=script&lang=js"

import "./readEventClub.vue?vue&type=style&index=0&id=039639a2&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__